module.exports = __webpack_public_path__ + "img/northeast-winter-1920x550.48f9d2f2.jpg";